<ng-container *ngIf="isLoading; else loaded">
    <mat-skeleton-loader
        count="5"
        [theme]="{ 
            'height.px': 50,
            'width.px': 200,
            'background-color': 'white',
            border: '1px solid white'
        }"
    ></mat-skeleton-loader>
</ng-container>
<ng-template #loaded>
    <div class="main-container">
        <div class="left">
            <mat-list>
                <ng-container *ngFor="let item of navList">
                    <ng-container *appHasModuleAccess="item.module">
                        <mat-list-item 
                            *appHasFeature="item.feature"
                            appPreventDoubleClick (throttledClick)="setSubSectionInUrl(item.route)" 
                            class="primaryHoverColor" 
                            [ngClass]="{'primaryColor': subSection === item.route }"
                            appLocalizationPopupDirective 
                            [localizationCode]="item.text"
                            setColor
                            [setColorRules]="[
                                {
                                    color: 'primaryColour',
                                    events: ['hover']
                                },
                                {
                                    color: 'primaryColour',
                                    setIfClass: ['primaryColor'],
                                    events: ['routerLinkActive']
                                },
                            ]"
                        >
                            {{ translate.instant(item.text) }}
                        </mat-list-item>
                    </ng-container>
                </ng-container>
            </mat-list>
        </div>

        <div class="main-content" [ngSwitch]="subSection">
            <app-employee-leave *ngSwitchCase="'TimeOffHistory'" [employeeId]="employeeId"></app-employee-leave>
            <app-employee-toil-history *ngSwitchCase="'TOIL'" [employeeId]="employeeId"></app-employee-toil-history>
            <app-employee-buy-sell *ngSwitchCase="'BuySell'" [employeeId]="employeeId"></app-employee-buy-sell>
        </div>
    </div>
</ng-template>